export default "__VITE_ASSET__53da0330__"